// Selector reutilizable de la biblioteca de medios (signage.media). Se abre como
// modal desde el editor de plantillas (escenas imagen/video) o desde retail media
// (banner). Devuelve el recurso elegido vía onPick.
import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Film, Image as ImageIcon } from 'lucide-react';
import { PanelIntegrado } from '@/components/ui/PanelIntegrado';
import { MediaAsset, sigList } from './shared';

export function MediaPicker({ tipo, onPick, onClose }: { tipo?: 'imagen' | 'video'; onPick: (a: MediaAsset) => void; onClose: () => void }) {
  const [q, setQ] = useState('');
  const { data: medios = [], isLoading } = useQuery<MediaAsset[]>({
    queryKey: ['sig-media'], queryFn: () => sigList<MediaAsset>('media?select=*&deleted_at=is.null&order=created_at.desc'), staleTime: 0,
  });
  const filtrados = useMemo(
    () => medios.filter((m) => (!tipo || m.tipo === tipo)
      && (m.tipo !== 'video' || !!m.url)   // oculta videos aún en proceso (sin url)
      && (!q || m.nombre.toLowerCase().includes(q.toLowerCase()))),
    [medios, tipo, q],
  );

  return (
    <PanelIntegrado title={`Biblioteca de medios${tipo ? ` — ${tipo === 'imagen' ? 'imágenes' : 'videos'}` : ''}`} onClose={onClose} wide>
      <input className="mb-3 h-9 rounded-md border bg-background px-2 text-sm w-48" placeholder="Buscar…" value={q} onChange={(e) => setQ(e.target.value)} />
      <div className="max-h-[70vh] overflow-y-auto">
        {isLoading ? <div className="text-sm text-muted-foreground py-8 text-center">Cargando…</div>
          : !filtrados.length ? <div className="text-sm text-muted-foreground py-8 text-center">Sin recursos. Súbelos en Signage → Biblioteca.</div>
          : (
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
              {filtrados.map((m) => (
                <button key={m.id} className="group border rounded-lg overflow-hidden text-left hover:ring-2 ring-primary" onClick={() => { onPick(m); onClose(); }}>
                  <div className="aspect-video bg-muted flex items-center justify-center overflow-hidden">
                    {m.tipo === 'imagen' && m.datos ? <img src={m.datos} alt={m.nombre} className="w-full h-full object-cover" />
                      : m.poster ? <img src={m.poster} alt={m.nombre} className="w-full h-full object-cover" />
                      : m.tipo === 'video' ? <Film className="w-8 h-8 text-muted-foreground" /> : <ImageIcon className="w-8 h-8 text-muted-foreground" />}
                  </div>
                  <div className="p-2 text-xs truncate" title={m.nombre}>{m.nombre}</div>
                </button>
              ))}
            </div>
          )}
      </div>
    </PanelIntegrado>
  );
}
